import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import * as React from "react";
import Text from "./Text";

export type BreadcrumbsProps = {
  items: { label: string; path: string }[];
  className?: string;
};

export default function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  const navigate = useNavigate();
  return (
    <div
      className={twMerge(
        "h-[56px] bg-secondary px-[16px] shadow-soft flex items-center",
        className,
      )}
    >
      {items.map((c, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <React.Fragment key={idx}>
            {!!idx && (
              <Text className={"text-text-surface mx-[8px]"} children="/" />
            )}
            <Text
              children={c.label}
              onClick={() => !isLast && navigate(c.path)}
              className={twMerge(
                "text-text-surface",
                !isLast &&
                  "cursor-pointer hover:underline hover:underline-offset-4",
              )}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
}
